import * as React from 'react';
import { SVGProps } from 'react';
import { Box, BoxProps } from '@mui/material';

const SpinnerSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <circle cx="12" cy="12" r="10" fill="none" stroke="#484F61FF" strokeWidth="1.25" opacity="0.25" />
    <circle cx="12" cy="12" r="10" fill="none" stroke="#484F61FF" strokeWidth="1.25" strokeLinecap="round" strokeDasharray="10 50">
      <animateTransform attributeName="transform" dur="1.25s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12" />
    </circle>
  </svg>
);

const HistoricSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54" width="1em" height="1em" fill="none" {...props}>
    <path
      fill="#484F61"
      fillRule="evenodd"
      d="M18 18.087c0-.6.487-1.087 1.087-1.087h15.337a1.088 1.088 0 0 1 0 2.175h-1.473c.064.192.128.387.189.582.216.688.416 1.434.489 2.196.074.77.02 1.583-.29 2.392-.313.813-.86 1.554-1.673 2.218a6.914 6.914 0 0 1-.84.587c.295.176.576.372.84.587.812.664 1.36 1.405 1.673 2.218.31.81.364 1.622.29 2.392-.073.761-.273 1.508-.49 2.196-.06.195-.124.39-.188.582h1.473a1.088 1.088 0 0 1 0 2.175H19.087a1.088 1.088 0 0 1 0-2.175h1.474a34.487 34.487 0 0 1-.19-.582c-.215-.688-.415-1.434-.488-2.196-.074-.77-.021-1.583.29-2.392.313-.813.86-1.554 1.672-2.218.264-.215.545-.411.84-.587a6.908 6.908 0 0 1-.84-.587c-.812-.664-1.36-1.405-1.672-2.218-.311-.81-.364-1.622-.29-2.392.073-.761.273-1.508.489-2.196.06-.195.125-.39.189-.582h-1.474c-.6 0-1.087-.487-1.087-1.088Zm4.855 17.038h7.8l.087-.257.023-.067c.105-.312.206-.612.3-.91.2-.64.347-1.216.399-1.752.05-.526.006-.984-.155-1.403-.16-.414-.459-.857-1.019-1.315-.907-.74-2.176-1.183-3.534-1.183-1.359 0-2.628.442-3.535 1.183-.56.458-.859.9-1.018 1.315-.161.419-.206.877-.155 1.403.051.536.198 1.112.399 1.753.093.297.194.597.3.909l.022.067.087.257Zm0-15.95h7.8l.087.257.023.067c.105.312.206.612.3.91.2.64.347 1.216.399 1.752.05.526.006.984-.155 1.403-.16.414-.459.857-1.019 1.315-.907.74-2.176 1.183-3.534 1.183-1.359 0-2.628-.442-3.535-1.183-.56-.458-.859-.9-1.018-1.315-.161-.419-.206-.877-.155-1.404.051-.535.198-1.111.399-1.752.093-.297.194-.597.3-.909l.022-.067.087-.257Z"
      clipRule="evenodd"
    />
  </svg>
);

export const WidgetHistoricLoadingAnimation = ({ width = 54, height = 54, ...props }: BoxProps) => (
  <Box
    {...props}
    sx={{
      position: 'relative',
      width,
      height,
      '& svg': { width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 },
      ...props.sx,
    }}>
    <SpinnerSvg />
    <HistoricSvg />
  </Box>
);
